import { useState, createContext, useEffect } from 'react';
import { LocalServer } from './templates/WebIp';
import { Authentication } from './templates/authentication';
import { Dashboard } from './templates/dashboard';
import { Invoice } from './templates/invoice';
import { DayCloseReportModal } from './templates/dayCloseReportModal';
import 'jquery-confirm';
import * as XLSX from "xlsx";
import { makeGetCall, makePostCall, handleApiError } from './utils/apiHelper';
export const AppContext = createContext();

function App() {
  var link = LocalServer();
  const [authForm, setAuthForm] = useState(true);
  const [accessToken, setAccessToken] = useState();
  const [page, setPage] = useState('dashboard');
  const [dayClose, setDayClose] = useState(false);
  const [closeDayReport, setCloseDayReport] = useState();
  const [user, setUser] = useState();
  const [account, setAccount] = useState()
  const [expenseParti, setExpenseParti] = useState();
  const [expense, setExpense] = useState();
  const [load, setLoad] = useState(false);
  const [pettyExpense, setPettyExpense] = useState();
  const [salaryStaff, setSalaryStaff] = useState();
  const [salaryCalcRepo, setSalaryCalcRepo] = useState();
  const [salaryPayRepo, setSalaryPayRepo] = useState();
  const [tokenTimeout, setTokenTimeout] = useState(null);
  const [submittedTimeout, setSubmittedTimeout] = useState(null);
  const [isDocumentVisible, setIsDocumentVisible] = useState(true);
  const [enquiryTypes, setEnquiryTypes] = useState();
  const [dayCloseReportModal, setDayCloseReportModal] = useState(false);
  const [getDayReportLoad, setGetDayReportload] = useState(false);
  const [leads, setLeads] = useState();
  async function fetchTokens() {
    if (!isDocumentVisible) return;

    try {
      // Await the response to ensure the function waits
      const response = await getTokens();
      if (response?.status === 200) {
        // Only set a new timeout if the response is successful
        setTokenTimeout(setTimeout(fetchTokens, 15000));
      } else {
        setTokenTimeout(setTimeout(fetchTokens, 30000));
        console.error("getTokens failed or returned an invalid response.");
      }
    } catch (error) {
      setTokenTimeout(setTimeout(fetchTokens, 30000));
      console.error("Error fetching tokens:", error);
    }
  }

  async function fetchSubmitted() {
    if (!isDocumentVisible) return;

    try {
      // Await the response to ensure the function waits
      const response = await getSubmitted();
      if (response?.status === 200) {
        setSubmittedTimeout(setTimeout(fetchSubmitted, 15000));
      } else {
        setSubmittedTimeout(setTimeout(fetchSubmitted, 30000));
        console.error("getSubmitted failed or returned an invalid response.");
      }
    } catch (error) {
      setSubmittedTimeout(setTimeout(fetchSubmitted, 30000));
      console.error("Error fetching submitted data:", error);
    }
  }
  useEffect(() => {
    // Call getHomePage only once when the user is available
    if (user) {
      setDayClose(user.day_status);
      setAccount(user.account);
      getHomePage();  // This will only be called once when user changes

      // Start the timeouts only once the user object is set
      const { token, token_settle } = user.permission || {};
      if (user.type === 'admin' || (token && Object.values(token).includes(true))) {
        setTokenTimeout(setTimeout(fetchTokens, 100));
      }

      if (user.type === 'admin' || (token_settle?.X)) {
        setSubmittedTimeout(setTimeout(fetchSubmitted, 100));
      }
    }

    return () => {
      // Clear timeouts on cleanup
      clearTimeout(tokenTimeout);
      clearTimeout(submittedTimeout);
    };
  }, [user]);  // Ensure useEffect only runs when `user` changes

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("Document hidden");
        console.log("Token Timeout:", tokenTimeout);
        console.log("Submitted Timeout:", submittedTimeout);
        setIsDocumentVisible(false);
        // Clear timeouts only if they are set (not null)
        if (tokenTimeout) {
          clearTimeout(tokenTimeout);
          console.log("Token timeout cleared");
        }

        if (submittedTimeout) {
          clearTimeout(submittedTimeout);
          console.log("Submitted timeout cleared");
        }
      } else {
        console.log("Document visible");
        setIsDocumentVisible(true);
        if (user) {
          const { token, token_settle } = user.permission || {};
          if (user.type === 'admin' || (token && Object.values(token).includes(true))) {
            setTokenTimeout(setTimeout(fetchTokens, 100));
          }

          if (user.type === 'admin' || (token_settle?.X)) {
            setSubmittedTimeout(setTimeout(fetchSubmitted, 100));
          }
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Clean up the listener when the component unmounts
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user, tokenTimeout, submittedTimeout]);

  const getCall = (loadfn, path, setfn) => {
    makeGetCall(link, path, accessToken, loadfn, setfn, setAuthForm).catch(() => { });
  }
  const postCall = (path, data) => {
    return makePostCall(link, path, data, accessToken, setAuthForm);
  }
  const [permissions, setPermissions] = useState();
  const [getPermiLoad, setGetPermiLoad] = useState(false);
  const getPermissions = () => {
    makeGetCall(link, 'api/pnp/get/permissions/', accessToken, setGetPermiLoad, setPermissions, setAuthForm).catch(() => { });
  }
  const [staffTypes, setStaffTypes] = useState();
  const [getStaffTypeLoad, setGetStaffTypeLoad] = useState(false);
  const getStaffTypes = () => {
    makeGetCall(link, 'api/pnp/get/staff/type/', accessToken, setGetStaffTypeLoad, setStaffTypes, setAuthForm).catch(() => { });
  }
  const [staffs, setStaffs] = useState();
  const [getStaffsLoad, setGetStaffsLoad] = useState(false);
  const getStaffs = () => {
    makeGetCall(link, 'api/pnp/get/staff/', accessToken, setGetStaffsLoad, setStaffs, setAuthForm).catch(() => { });
  }
  const [services, setServices] = useState();
  const [getServiceLoad, setGetServiceLoad] = useState(false);
  const getServices = () => {
    makeGetCall(link, 'api/snp/get/service/', accessToken, setGetServiceLoad, setServices, setAuthForm).catch(() => { });
  }
  const [customers, setCustomers] = useState();
  const [getCustomersLoad, setGetCustomersLoad] = useState(false);
  const getCustomers = () => {
    makeGetCall(link, 'api/cp/get/customer/', accessToken, setGetCustomersLoad, setCustomers, setAuthForm).catch(() => { });
  }
  const [getEnquiryLoad, setGetEnquiryLoad] = useState(false);
  const [enquiry, setEnquiry] = useState();
  const getEnquiry = () => {
    makeGetCall(link, 'api/e/get/enquiry/', accessToken, setGetEnquiryLoad, setEnquiry, setAuthForm).catch(() => { });
  }
  const [getWorkLoad, setGetWorkLoad] = useState(false);
  const [works, setWorks] = useState();
  const getWorks = () => {
    makeGetCall(link, 'api/e/get/pending/work/', accessToken, setGetWorkLoad, setWorks, setAuthForm).catch(() => { });
  }
  const [tokens, setTokens] = useState();
  const [closeDayState, setCloseDayState] = useState(false);
  useEffect(() => {
    if (tokens !== undefined) {
      if (Object.keys(tokens).length > 0) {
        let p = new Promise((resolve, reject) => {
          Object.keys(tokens).map(tok => {
            if (tokens[tok].status === 'open') {
              if (user.profile.user_id === tokens[tok].user_id) {
                resolve();
              }
            }
          });
          reject();
        });
        p.then(res => {
          setCloseDayState(false);
        }).catch(err => {
          setCloseDayState(true);
        });
      } else {
        setCloseDayState(true);
      }
    }
  }, [tokens]);
  const [getTokenLoad, setGetTokenLoad] = useState(false);
  const [stateSettle, setStateSettle] = useState(false);
  const [stateSettleAll, setStateSettleAll] = useState(false);

  const getTokens = () => {
    setGetTokenLoad(true);
    return makeGetCall(link, 'api/mt/get/token/', accessToken, null, null, setAuthForm)
      .then(response => {
        setGetTokenLoad(false);
        setTokens(response.data.tokens);
        setStateSettle(response.data.settle);
        setStateSettleAll(response.data.settle_all);
        return response;
      })
      .catch(err => {
        setGetTokenLoad(false);
        throw err;
      });
  };

  const [submittedTokens, setSubmittedTokens] = useState();
  const [getSubitLoad, setGetSubmitLoad] = useState(false);
  const getSubmitted = () => {
    setGetSubmitLoad(true);
    return makeGetCall(link, 'api/mt/get/token/submitted/', accessToken, null, null, setAuthForm)
      .then(response => {
        setGetSubmitLoad(false);
        setSubmittedTokens(response.data.tokens);
        setStateSettle(response.data.settle);
        setStateSettleAll(response.data.settle_all);
        return response;
      })
      .catch(err => {
        setGetSubmitLoad(false);
        throw err;
      });
  }

  const [tokenServices, setTokenServices] = useState();
  const [tokenServiceLoad, setTokenServiceLoad] = useState(false);
  const getTokenServices = () => {
    makeGetCall(link, 'api/mt/get/service/', accessToken, setTokenServiceLoad, setTokenServices, setAuthForm).catch(() => { });
  }

  const [tokenCustomers, setTokenCustomers] = useState();
  const [getTokenCustomerLoad, setGetTokenCustomerLoad] = useState(false);
  const getTokenCustomers = () => {
    makeGetCall(link, 'api/mt/get/customer/', accessToken, setGetTokenCustomerLoad, setTokenCustomers, setAuthForm).catch(() => { });
  }

  const [payMethods, setPayMethods] = useState();
  const [getPayMethodLoad, setGetPayMethodLoad] = useState(false);
  const getPaymentMethods = () => {
    makeGetCall(link, 'api/pm/get/payment/method/', accessToken, setGetPayMethodLoad, setPayMethods, setAuthForm).catch(() => { });
  }

  const [payModes, setPayModes] = useState();
  const [getPayModesLoad, setGetPayModesLoad] = useState(false);
  const getPayModes = () => {
    makeGetCall(link, 'api/pm/get/payment/method/', accessToken, setGetPayModesLoad, setPayModes, setAuthForm).catch(() => { });
  }

  const [collections, setCollections] = useState();
  const [getCollectionLoad, setGetCollectionLoad] = useState(false);
  const getCollections = (date = getDate()) => {
    setGetCollectionLoad(true);
    makePostCall(link, 'api/bnr/get/collection/', { date: date }, accessToken, setAuthForm).then(res => {
      setCollections(res.data);
      setGetCollectionLoad(false);
    }).catch(() => {
      setGetCollectionLoad(false);
    });
  }

  const [notifications, setNotification] = useState();
  const [getNotifiLoad, setGetNotifiLoad] = useState(false);
  const getNotifications = () => {
    makeGetCall(link, 'api/np/get/notifications/', accessToken, setGetNotifiLoad, setNotification, setAuthForm).catch(() => { });
  }

  const [specialTokens, setSpecialTokens] = useState();
  const [specialTokenLoad, setSpecialTokenLoad] = useState(false);
  const getSpecialTokens = () => {
    makeGetCall(link, 'api/mt/get/special/token/', accessToken, setSpecialTokenLoad, setSpecialTokens, setAuthForm).catch(() => { });
  }

  const [dayCloseToVerify, setDayCloseToVerify] = useState();
  const [dayCloseToVerifyLoad, setDayCloseToVerifyLoad] = useState(false);
  const getDayCloseToVerify = () => {
    makeGetCall(link, 'api/pnp/day/close/unverified/reports/', accessToken, setDayCloseToVerifyLoad, setDayCloseToVerify, setAuthForm).catch(() => { });
  }

  const [credits, setCredits] = useState();
  const [getCreditLoad, setGetCreditLoad] = useState(false);
  const getCredits = () => {
    makeGetCall(link, 'api/bnr/get/credits/', accessToken, setGetCreditLoad, setCredits, setAuthForm).catch(() => { });
  }

  const [quickReport, setQuickReport] = useState();
  const [getQuickReportLoad, setGetQuickReporLoad] = useState(false);
  const getQuickReport = () => {
    if (quickReport === undefined) {
      makeGetCall(link, 'api/bnr/get/quick/report/history/', accessToken, setGetQuickReporLoad, setQuickReport, setAuthForm).catch(() => { });
    }
  }
  const [quickReportYear, setQuickReportYear] = useState();
  const [getQuickReportYearLoad, setGetQuickReporYearLoad] = useState(false);
  const getQuickReportYear = () => {
    if (quickReport === undefined) {
      makeGetCall(link, 'api/bnr/get/quick/report/year/', accessToken, setGetQuickReporYearLoad, setQuickReportYear, setAuthForm).catch(() => { });
    }
  }
  const [quickReportToday, setQuickReportToday] = useState();
  const [getQuickReportTodayLoad, setGetQuickReporTodayLoad] = useState(false);
  const getQuickReportToday = () => {
    makeGetCall(link, 'api/bnr/get/quick/report/', accessToken, setGetQuickReporTodayLoad, setQuickReportToday, setAuthForm).catch(() => { });
  }
  const [customerReport, setCustomerReport] = useState();
  const [getCustomerReportLoad, setGetCustomerReportLoad] = useState(false);
  const getDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }
  const [date, setDate] = useState(getDate());
  const getCustomerReport = (start_date = getDate(), end_date = getDate()) => {
    setGetCustomerReportLoad(true);
    makePostCall(link, 'api/bnr/get/customer/report/', { start_date, end_date }, accessToken, setAuthForm)
      .then(res => {
        setGetCustomerReportLoad(false);
        setCustomerReport(res.data);
      })
      .catch(() => setGetCustomerReportLoad(false));
  }
  const [serviceReport, setServiceReport] = useState();
  const [getServiceReportLoad, setGetServiceReportLoad] = useState(false);
  const getServiceReport = (start_date = getDate(), end_date = getDate()) => {
    setGetServiceReportLoad(true);
    makePostCall(link, 'api/bnr/get/service/report/', { start_date, end_date }, accessToken, setAuthForm)
      .then(res => {
        setGetServiceReportLoad(false);
        setServiceReport(res.data);
      })
      .catch(() => setGetServiceReportLoad(false));
  }
  const [bill, setBill] = useState();
  const [getBillLoad, setGetBillLoad] = useState(false);
  const [viewBillModal, setViewBillModal] = useState(false);
  const getBill = (bpk) => {
    setGetBillLoad(true);
    makePostCall(link, 'api/bnr/get/bill/by/id/', { bill_id: bpk }, accessToken, setAuthForm)
      .then(res => {
        setGetBillLoad(false);
        setBill(res.data);
      })
      .catch(() => setGetBillLoad(false));
  }
  const [staffReport, setStaffReport] = useState();
  const [staffReportLoad, setStaffReportLoad] = useState();
  const getStaffReport = (start_date = getDate(), end_date = getDate()) => {
    setStaffReportLoad(true);
    makePostCall(link, 'api/bnr/get/staff/report/', { start_date, end_date }, accessToken, setAuthForm)
      .then(res => {
        setStaffReportLoad(false);
        setStaffReport(res.data);
      })
      .catch(() => setStaffReportLoad(false));
  }
  const [collectionReport, setCollectionReport] = useState();
  const [collectionReportLoad, setCollectionReportLoad] = useState(false);
  const getCollectionReport = (start_date = getDate(), end_date = getDate()) => {
    setCollectionReportLoad(true);
    makePostCall(link, 'api/bnr/get/collection/report/', { start_date, end_date }, accessToken, setAuthForm)
      .then(res => {
        setCollectionReportLoad(false);
        setCollectionReport(res.data);
      })
      .catch(() => setCollectionReportLoad(false));
  }
  const [creditReport, setCreditReport] = useState();
  const [creditReportLoad, setCreditReportLoad] = useState(false);
  const getCreditReport = (start_date = getDate(), end_date = getDate(), staff_id = "") => {
    setCreditReportLoad(true);
    makePostCall(link, 'api/bnr/get/credit/report/', { start_date, end_date, staff_id }, accessToken, setAuthForm)
      .then(res => {
        setCreditReportLoad(false);
        setCreditReport(res.data);
      })
      .catch(() => setCreditReportLoad(false));
  }
  const [detailReport, setDetailReport] = useState();
  const [detailReportLoad, setDetailReportLoad] = useState(false);
  const getDetailReport = (start_date = getDate(), end_date = getDate(), staff_id = "", service_id = "") => {
    setDetailReportLoad(true);
    makePostCall(link, 'api/bnr/get/detailed/report/', { start_date, end_date, staff_id, service_id }, accessToken, setAuthForm)
      .then(res => {
        setDetailReportLoad(false);
        setDetailReport(res.data);
      })
      .catch(() => setDetailReportLoad(false));
  }
  const [cancelReport, setCancelReport] = useState();
  const [cancelReportLoad, setCancelReportLoad] = useState(false);
  const getCancelReport = (start_date = getDate(), end_date = getDate(), staff_id = "") => {
    setCancelReportLoad(true);
    makePostCall(link, 'api/bnr/get/token/cancel/report/', { start_date, end_date, staff_id }, accessToken, setAuthForm)
      .then(res => {
        setCancelReportLoad(false);
        setCancelReport(res.data);
      })
      .catch(() => setCancelReportLoad(false));
  }
  const [home, setHome] = useState();
  const [homeLoad, setHomeLoad] = useState(false);
  const getHomePage = () => {
    makeGetCall(link, 'api/hp/get/home/page/', accessToken, setHomeLoad, setHome, setAuthForm).catch(() => { });
  }
  const [specialBills, setSpecialBills] = useState();
  const [specialBillsLoad, setSpecialBillsLoad] = useState(false);
  const [billDate, setBillDate] = useState(getDate());
  const getSpecialBills = () => {
    setSpecialBillsLoad(true);
    makePostCall(link, 'api/ab/get/bills/', { date: billDate }, accessToken, setAuthForm)
      .then(res => {
        setSpecialBillsLoad(false);
        setSpecialBills(res.data);
      })
      .catch(() => setSpecialBillsLoad(false));
  }
  useEffect(() => {
    if (billDate !== undefined && user !== undefined) {
      getSpecialBills();
    }
  }, [billDate]);
  const [getLoad, setGetLoad] = useState(false);
  const [staffTokenReport, setStaffTokenReport] = useState();
  const [detailTreport, setDetailTreport] = useState();
  const [incompleteTokenReport, setIncompleteTokenReport] = useState();
  const [payWallet, setPayWallet] = useState();
  const [payWalletReport, setPayWalletReport] = useState();
  const [walletCus, setWalletCus] = useState();
  const [expenseReport, setExpenseReport] = useState();
  const [reOpenRepo, setReOpenRepo] = useState();
  const [attendence, setAttendence] = useState();
  const [smDiStaff, setSmDiStaffs] = useState();
  const downloadExcel = (data, filename) => {
    if (data !== undefined && filename !== undefined && filename !== "") {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, filename);
    }
  }
  const formatDateTime = (isoString) => {
    if (!isoString) return '-';
    const d = new Date(isoString);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };
  return (
    <AppContext.Provider value={{
      authForm, setAuthForm, link, getCall, postCall, getLoad, setGetLoad, accessToken, setAccessToken, page, setPage, user, setUser,
      getPermissions, getPermiLoad, permissions, staffs, setStaffs, getStaffs, getStaffsLoad, staffTypes, setStaffTypes, closeDayState,
      getStaffTypes, getStaffTypeLoad, services, setServices, getServices, getServiceLoad, customers, setCustomers, getCustomersLoad,
      getCustomers, getEnquiryLoad, getEnquiry, enquiry, setEnquiry, setGetEnquiryLoad, getTokens, tokens, setTokens, getTokenLoad,
      getTokenServices, tokenServices, setTokenServices, tokenServiceLoad, getTokenCustomers, tokenCustomers, setTokenCustomers,
      getTokenCustomerLoad, payMethods, setPayMethods, getPaymentMethods, getPayMethodLoad, getPayModes, payModes, dayClose,
      setDayClose, collections, getCollectionLoad, getCollections, getNotifications, notifications, getNotifiLoad, setNotification,
      setGetNotifiLoad, closeDayReport, setCloseDayReport, getSpecialTokens, specialTokens, setSpecialTokens, specialTokenLoad, smDiStaff, setSmDiStaffs,
      date, setDate, account, setAccount, getDayCloseToVerify, dayCloseToVerify, setDayCloseToVerify, dayCloseToVerifyLoad, attendence, setAttendence,
      getCredits, credits, setCredits, getCreditLoad, getQuickReport, getQuickReportLoad, quickReport, getCustomerReport, salaryStaff, setSalaryStaff,
      customerReport, getCustomerReportLoad, getDate, serviceReport, getServiceReportLoad, getServiceReport, getBill, reOpenRepo, setReOpenRepo,
      setViewBillModal, viewBillModal, bill, setBill, getBillLoad, getStaffReport, staffReport, staffReportLoad, getCollectionReport, collectionReport, expense, setExpense, expenseReport, setExpenseReport,
      collectionReportLoad, getCreditReport, creditReport, creditReportLoad, getDetailReport, detailReport, detailReportLoad, pettyExpense, setPettyExpense,
      getCancelReport, cancelReport, cancelReportLoad, getHomePage, home, homeLoad, getSpecialBills, specialBills, expenseParti, setExpenseParti,
      specialBillsLoad, setSpecialBills, getQuickReportToday, quickReportToday, getQuickReportTodayLoad, billDate, setBillDate, getWorks, load, setLoad,
      works, getWorkLoad, setGetWorkLoad, setWorks, getSubmitted, getSubitLoad, submittedTokens, setSubmittedTokens, stateSettle, walletCus, setWalletCus,
      stateSettleAll, setStateSettle, setStateSettleAll, quickReportYear, getQuickReportYear, getQuickReportYearLoad, staffTokenReport, setStaffTokenReport,
      detailTreport, setDetailTreport, incompleteTokenReport, setIncompleteTokenReport, payWallet, setPayWallet, payWalletReport, setPayWalletReport, salaryCalcRepo,
      setSalaryCalcRepo, salaryPayRepo, setSalaryPayRepo, downloadExcel, makeGetCall, makePostCall, handleApiError, enquiryTypes,
      setEnquiryTypes, dayCloseReportModal, setDayCloseReportModal, getDayReportLoad, setGetDayReportload, leads, setLeads, formatDateTime
    }} >
      <Invoice />
      <DayCloseReportModal />
      {
        user === undefined ? (
          <Authentication />
        ) : (
          <Dashboard />
        )
      }
    </AppContext.Provider>
  );
}
export default App;
